/**
 * =================
 * COOKIES MINI TOOL
 * tool
 * =================
 */

import { pick } from "underscore";


export class Cookie {
    defaults = {
        expires: '',
        path: '/',
        domain: ''
    };

    urlAttrsRe = {
        path: /[^/]*\/.*/,
        domain: /([www])?\.?((\w+)\.+)([a-zA-Z]{2,})/gi
    };

    set(name, val, expiryDays, path, domain) {
        let expires;
        if (expiryDays) {
            const date = new Date();
            date.setTime(date.getTime() + (expiryDays * 24 * 60 * 60 * 1000));
            expires = date.toGMTString();
        }

        return document.cookie = this.getCookieString(name, val, {
            expires: expires || this.defaults.expires,
            path: path || this.defaults.path,
            domain: domain || this.defaults.domain
        });
    }

    get(name) {
        // normalize cookie name
        const cookieName = name + "=";

        // split set of cookies into arry
        const cookies = document.cookie ? document.cookie.split(';') : [];

        for (let i = 0, l = cookies.length; i < l; i++) {
            const cookie = cookies[i].replace(/^\s+|\s+$/g, ''); // trim it!

            if (cookie.match(cookieName) !== null) {
                return cookie.substring(cookieName.length, cookie.length);
            }
        }
        // otherwise return empty
        return "";
    }

    remove(name, path_or_domain, domain_or_path) {
        if (!this.get(name)) {
            return false;
        }

        // get url attrs from given aux args
        const attrs = this.getUrlAttrs(Array.prototype.slice.call(arguments, 1));

        this.set(name, '', -1, attrs.path, attrs.domain);
        return !this.get(name);
    }

    // fn's
    getCookieString(name, val, attrs) {
        const ret = [name + '=' + val];
        const props = Object.keys(attrs);

        for (let i = 0, l = props.length; i < l; i++) {
            const prop = props[i],
                val = attrs[prop];
            val && ret.push([prop, val].join('='));
        }

        return ret.join('; ');
    }

    getUrlAttrs(values) {
        const attrs = pick(defaults, 'domain', 'path');
        let nth = values.length;

        while (nth--) {
            const val = values[nth];
            for (let attr in this.urlAttrsRe) {
                if (this.urlAttrsRe[attr].test(val)) {
                    attrs[attr] = val;
                }
            }
        }

        return attrs;
    }
}
